import Vue from "vue";
import Vuex from "vuex";

import ui from "./ui";
import usuarios from "./usuarios";
import condicaoPagamento from "./condicaoPagamento";
import formaPgto from "./formaPgto";
import contaBancaria from "./contaBancaria";
import unidadeMedida from "./unidadeMedida";
import grupoItem from "./grupoItem";
import subGrupoItem from "./subGrupoItem";
import licenca from "./licenca";
import permissao from "./permissao";
import item from "./item";
import empresa from "./empresa";
import funcionario from "./funcionario";
import equipamento from "./equipamento";
import documento from "./documento";
import ordemMedicao from "./ordemMedicao";
import relatorio from "./relatorio";
import endereco from "./endereco";
import vendedor from "./vendedor";
import cliente from "./cliente";
import entidade from "./entidade";
import fornecedor from "./fornecedor";
import boleto from "./boleto";
import contato from "./contatos";
import contasReceber from "./contasReceber";
import taxonomia from "./taxonomia";
import email from "./email";
import cnab from "./cnab";
import contasPagar from "./contasPagar";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    ui,
    usuarios,
    condicaoPagamento,
    formaPgto,
    contaBancaria,
    unidadeMedida,
    grupoItem,
    subGrupoItem,
    licenca,
    permissao,
    item,
    empresa,
    funcionario,
    equipamento,
    documento,
    ordemMedicao,
    relatorio,
    endereco,
    vendedor,
    cliente,
    entidade,
    fornecedor,
    boleto,
    contato,
    contasReceber,
    taxonomia,
    email,
    cnab,
    contasPagar
  }
});
